import { getGsap } from "./GsapGlobals";

export class ParallaxImageController {
    static init(): void {
        const gsap = getGsap();
        if (!gsap) return;
        const images = document.querySelectorAll<HTMLImageElement>(".move-img img");
        if (images.length === 0) return;

        gsap.set(images, { scale: 1.1 });

        images.forEach((image) => {
            gsap.fromTo(
                image,
                { yPercent: -15 },
                {
                    yPercent: 0,
                    scrollTrigger: {
                        trigger: image,
                        start: "top-=10% bottom",
                        end: "bottom+=20% top",
                        scrub: 1,
                    },
                },
            );
        });
    }
}
